import { useState, useEffect } from "react";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonAvatar from "components/ArgonAvatar";
import ArgonButton from "components/ArgonButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Link } from "react-router-dom";
import axios, { baseURL } from "utils/api";
import { toast } from "react-toastify";

const useSubjectData = (handleDeleteClick, handleEditClick, refresh) => {
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);

  const columns = [
    { name: "sno", align: "center" },
    { name: "Subject", align: "center" },
    { name: "Board", align: "center" },
    { name: "action", align: "center" },
  ];

  useEffect(() => {
    axios
      .get(`${baseURL}/subjects`)
      .then((res) => {
        if (res.data.success) {
          const data = res.data.data;
          const activeSubjects = data.filter((subject) => !subject.isDeleted);
          setCount(activeSubjects.length);
          if (activeSubjects.length === 0) {
            setRows([
              {
                sno: <ArgonTypography variant="caption">-</ArgonTypography>,
                Subject: (
                  <ArgonTypography variant="caption" color="error">
                    No subjects available. Please add a subject.
                  </ArgonTypography>
                ),
                Board: <ArgonTypography variant="caption">-</ArgonTypography>,
                action: <ArgonTypography variant="caption">-</ArgonTypography>,
              },
            ]);
          } else {
            const formattedRows = activeSubjects.map((item, index) => ({
              sno: (
                <ArgonTypography variant="caption" fontWeight="medium" color="text">
                  {index + 1}
                </ArgonTypography>
              ),
              Subject: (
                <ArgonTypography variant="caption" fontWeight="medium" color="text">
                  {item.name}
                </ArgonTypography>
              ),
              Board: (
                <ArgonTypography variant="caption" fontWeight="medium" color="text">
                  {item.board?.name || "N/A"}
                </ArgonTypography>
              ),
              action: (
                <ArgonBox display="flex" alignItems="center" gap={0}>
                  <ArgonButton
                    variant="text"
                    size="large"
                    sx={{ minWidth: "12px", p: 0 }}
                    onClick={() => handleEditClick(item._id, item.name)}
                  >
                    <EditIcon color="warning" />
                  </ArgonButton>

                  <ArgonButton
                    variant="text"
                    size="large"
                    sx={{ minWidth: "32px", p: 0 }}
                    onClick={() => handleDeleteClick(item._id)}
                  >
                    <DeleteIcon color="error" />
                  </ArgonButton>
                </ArgonBox>
              ),
            }));

            setRows(formattedRows);
          }
        }
      })
      .catch((err) => {
        console.error("❌ Error fetching subjects:", err);
        const backendError = err.response?.data?.error;
        if (backendError) {
          toast.error(backendError);
        }
      });
  }, [refresh]);

  return { columns, rows, count };
};

export default useSubjectData;
